var render = function render(){var _vm=this,_c=_vm._self._c;return _c('label',{staticClass:"container"},[_c('input',{staticClass:"checkbox",attrs:{"type":"checkbox","disabled":_vm.disabled,"aria-checked":_vm.checked,"aria-label":_vm.ariaLabel},domProps:{"checked":_vm.checked},on:{"change":function($event){return _vm.handleChange($event)}}}),_c('span',{staticClass:"custom-checkbox",attrs:{"role":"checkbox"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }